import { render } from "./ThinkingProcess.vue?vue&type=template&id=2e359d28&scoped=true"
import script from "./ThinkingProcess.vue?vue&type=script&lang=js"
export * from "./ThinkingProcess.vue?vue&type=script&lang=js"

import "./ThinkingProcess.vue?vue&type=style&index=0&id=2e359d28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e359d28"]])

export default __exports__